module.exports = __webpack_public_path__ + "static/media/purchases.174bb259.svg";